module.exports = __webpack_public_path__ + "img/other_iQOO1.e4af15ee.jpg";